module.exports = __webpack_public_path__ + "img/paper-dark.8fda0960.svg";